import React, { useState } from 'react';
import styles from './css/Login.module.css';
import { TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { commonActions } from "../reducers/common";
import LoginService from "../service/apiConfig/LoginService";
import Swal from "sweetalert2";
import axios from "axios";

const Login = () => {
    const dispatch = useDispatch();
    const [input, setInput] = useState({
        id: '',
        password: ''
    })

    const { id, password } = input;
    const onChangeInput = (e) => {
        const { name, value } = e.target;
        setInput({
            ...input,
            [name]: value
        })
    }
    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            onSubmit();
        }
    }

    const onSubmit = (e, click) => {
        if (click) {
            e.preventDefault();
        }
        dispatch(commonActions.trueIsLoading());
        let data = {
            "username" : id,
            "password" : password
        }
        LoginService.create(data)
            .then(response => {
                dispatch(commonActions.falseIsLoading());
                if (response.data === 'login_001') {
                    dispatch(commonActions.falseIsLoading());
                    Swal.fire({
                        icon: "error",
                        text: "비밀번호를 다시 확인해주세요.",
                        confirmButtonText: '확인',
                    }).then(r =>{
                        return false
                    });
                } else if (response.data === 'login_002') {
                    dispatch(commonActions.falseIsLoading());
                    Swal.fire({
                        icon: "error",
                        text: "유저 정보가 없습니다.",
                        confirmButtonText: '확인',
                    }).then(r =>{
                        return false
                    });
                } else {
                    dispatch(commonActions.falseIsLoading());
                    let token = response.data.accessToken;
                    let refreshToken = response.data.refreshToken;
                    let user = response.headers.user;

                    if (localStorage.getItem('accessToken')) {
                        localStorage.removeItem('accessToken');
                        return;
                    }
                    let split = user.split(",");
                    let userString = "";
                    for (const string of split) {
                        userString += String.fromCharCode(string);
                    }
                    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    axios.defaults.withCredentials = true;

                    localStorage.setItem('accessToken', token);
                    localStorage.setItem('refreshToken', refreshToken);
                    localStorage.setItem('login', "true");
                    localStorage.setItem('user', userString);

                    dispatch(commonActions.setToken(token));
                    dispatch(commonActions.setUser(JSON.parse(userString)));
                    if (response.status === 200) {
                        window.location.replace("/setting/exhibition");
                    }
                }
            })
            .catch(err => {
                dispatch(commonActions.falseIsLoading());
                if (err) {
                    Swal.fire({
                        icon: "error",
                        text: "아이디 또는 비밀번호를 다시 확인해주세요.",
                        confirmButtonText: '확인',
                    }).then(r => {
                        return false
                    });
                }
            })
    }
    return (
        <div className={styles.loginWrap}>
            <div className={styles.loginContainer}>
                <h2>Login</h2>
                <form>
                    <TextField id="outlined-basic" sx={{ marginBottom: "1rem" }} onChange={onChangeInput} name={"id"} label="Id" variant="outlined" size="small" />
                    <TextField id="outlined-basic" sx={{ marginBottom: "1rem" }} onChange={onChangeInput} onKeyDown={(e) => onKeyDown(e)} name={"password"} label="Password" variant="outlined" size="small" type={"password"} />
                    <button onClick={(e) => onSubmit(e, true)} type={"button"}>로그인</button>
                </form>
            </div>
        </div>
    );
};

export default Login;